var _defs, _mask, _animateTransform, _animateTransform2, _animateTransform3, _animateTransform4, _animateTransform5, _animateTransform6, _animateTransform7, _animateTransform8, _animateTransform9, _animateTransform10, _animateTransform11, _animateTransform12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrainOutOfBoxAnimatedBubblesOutOfBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162.59mm",
    height: "199.99mm",
    viewBox: "0 0 162.59 199.99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3988"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98b5f6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98ffe1",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2838"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6efdfa",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6efdfa",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2218"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6efdfa",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bb2aff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6431"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8894-3-3",
    x: -0.63315,
    y: -1.9306,
    width: 2.2663,
    height: 4.8612,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8838-5-5",
    x: -0.54551,
    y: -0.87532,
    width: 2.091,
    height: 2.7506,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8846-38-2",
    x: -0.27351,
    y: -0.46267,
    width: 1.547,
    height: 1.9253,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8854-2-4",
    x: -1.0761,
    y: -1.4895,
    width: 3.1521,
    height: 3.9791,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8874-7-5",
    x: -0.93886,
    y: -1.2862,
    width: 2.8777,
    height: 3.5725,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8906-0-6",
    x: -1.1168,
    y: -0.85228,
    width: 3.2336,
    height: 2.7046,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8910-7-2",
    x: -3.4169,
    y: -1.0129,
    width: 7.8337,
    height: 3.0259,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8902-9-5",
    x: -0.59483,
    y: -0.57977,
    width: 2.1897,
    height: 2.1595,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8890-43-5",
    x: -0.48467,
    y: -0.43426,
    width: 1.9693,
    height: 1.8685,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8882-1-8",
    x: -0.23016,
    y: -0.3433,
    width: 1.4603,
    height: 1.6866,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8886-2-6",
    x: -2.1301,
    y: -0.55162,
    width: 5.2601,
    height: 2.1032,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8834-8-1",
    x: -0.3902,
    y: -0.39496,
    width: 1.7804,
    height: 1.7899,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8842-8-2",
    x: -0.20242,
    y: -0.44365,
    width: 1.4048,
    height: 1.8873,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8850-8-0",
    x: -0.33736,
    y: -1.0442,
    width: 1.6747,
    height: 3.0883,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8830-09-6",
    x: -1.4528,
    y: -0.53065,
    width: 3.9055,
    height: 2.0613,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8858-2-3",
    x: -0.2273,
    y: -0.22901,
    width: 1.4546,
    height: 1.458,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8826-8-0",
    x: -0.37542,
    y: -0.40533,
    width: 1.7508,
    height: 1.8107,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8862-2-9",
    x: -0.59159,
    y: -0.28256,
    width: 2.1832,
    height: 1.5651,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8866-4-1",
    x: -0.64744,
    y: -0.39618,
    width: 2.2949,
    height: 1.7924,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8870-37-7",
    x: -0.67472,
    y: -0.44982,
    width: 2.3494,
    height: 1.8996,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8878-2-9",
    x: -1.1541,
    y: -0.43182,
    width: 3.3082,
    height: 1.8636,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8898-1-2",
    x: -0.32066,
    y: -2.9445,
    width: 1.6413,
    height: 6.889,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8914-4-2",
    x: -0.89446,
    y: -0.5895,
    width: 2.7889,
    height: 2.179,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8918-5-5",
    x: -0.12361,
    y: -0.13466,
    width: 1.2472,
    height: 1.2693,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9723901
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11217-5-0",
    x: -0.53217,
    y: -0.39687,
    width: 2.0643,
    height: 1.7937,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4196-1",
    x: -0.0098856,
    y: -0.01345,
    width: 1.0198,
    height: 1.0269,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11572-96-2",
    x: -0.10993,
    y: -0.10993,
    width: 1.2199,
    height: 1.2199,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.79669993
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11201-65-4",
    x: -0.19843,
    y: -0.32521,
    width: 1.3969,
    height: 1.6504,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11193-6-8",
    x: -0.15147,
    y: -0.33634,
    width: 1.3029,
    height: 1.6727,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11205-3-8",
    x: -0.15715,
    y: -0.19037,
    width: 1.3143,
    height: 1.3807,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11221-3-5",
    x: -0.1501,
    y: -0.22956,
    width: 1.3002,
    height: 1.4591,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11213-4-5",
    x: -0.223,
    y: -0.65043,
    width: 1.446,
    height: 2.3009,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11197-3-1",
    x: -0.34494,
    y: -0.29971,
    width: 1.6899,
    height: 1.5994,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11225-5-5",
    x: -0.21287,
    y: -0.45029,
    width: 1.4257,
    height: 1.9006,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11229-0-6",
    x: -0.32076,
    y: -0.32078,
    width: 1.6415,
    height: 1.6416,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11209-1-5",
    x: -0.25178,
    y: -0.46831,
    width: 1.5036,
    height: 1.9366,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11189-9-3",
    x: -0.73172,
    y: -0.19193,
    width: 2.4634,
    height: 1.3839,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0083505
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4188-9",
    x: -0.045311,
    y: -0.039069,
    width: 1.0906,
    height: 1.0781,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4212-4",
    x: -0.078165,
    y: -0.04891,
    width: 1.1563,
    height: 1.0978,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.16894989
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4176-0",
    x: -0.036901,
    y: -0.036259,
    width: 1.0738,
    height: 1.0725,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4184-9",
    x: -0.10264,
    y: -0.093077,
    width: 1.2053,
    height: 1.1862,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4252-5",
    x: -0.10819,
    y: -0.031554,
    width: 1.2164,
    height: 1.0631,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.14690549
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4160-2",
    x: -0.025221,
    y: -0.033053,
    width: 1.0504,
    height: 1.0661,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4164-1",
    x: -0.02965,
    y: -0.02904,
    width: 1.0593,
    height: 1.0581,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4232-3",
    x: -0.010608,
    y: -0.0042672,
    width: 1.0212,
    height: 1.0085,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.032130895
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4152-5",
    x: -0.039746,
    y: -0.036782,
    width: 1.0795,
    height: 1.0736,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4144-4",
    x: -0.072924,
    y: -0.046093,
    width: 1.1458,
    height: 1.0922,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4148-1",
    x: -0.16732,
    y: -0.064124,
    width: 1.3346,
    height: 1.1282,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4216-4",
    x: -0.043595,
    y: -0.091122,
    width: 1.0872,
    height: 1.1822,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.16894989
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3141-1",
    x: -0.43638,
    y: -0.33879,
    width: 1.8728,
    height: 1.6776,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.59647872
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4172-9",
    x: -0.1473,
    y: -0.11515,
    width: 1.2946,
    height: 1.2303,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3669-8",
    x: -0.16513,
    y: -0.35413,
    width: 1.3303,
    height: 1.7083,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.63287511
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3687-8",
    x: -0.14758,
    y: -0.40319,
    width: 1.2952,
    height: 1.8064,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24308614
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient6544-9",
    cx: -1822.7,
    cy: 1007.9,
    r: 2.1818,
    gradientTransform: "matrix(.99977 .021454 -.020016 .93279 -2402.1 90.601)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2838"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient6433-4-2",
    cx: -1760.1,
    cy: 994.93,
    r: 2.4288,
    gradientTransform: "matrix(.99977 .021454 -.020163 .9396 -2401.9 82.952)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient6431"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter6495-1-45",
    x: -0.033104,
    y: -0.03565,
    width: 1.0662,
    height: 1.0713,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.056449642
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2840-3",
    x1: -1794.3,
    x2: -1789.2,
    y1: 977.82,
    y2: 977.82,
    gradientTransform: "translate(2.0242,-12.947)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2838"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter6793-4",
    x: -0.11884,
    y: -0.12799,
    width: 1.2377,
    height: 1.256,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.20265578
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient2874-7",
    cx: -1815.4,
    cy: 959.15,
    r: 2.5504,
    gradientTransform: "matrix(1,0,0,1.0337,2.0242,-45.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf4fe",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf4fe",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2900-6",
    x: -0.037973,
    y: -0.035662,
    width: 1.0759,
    height: 1.0713,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.076859028
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2958-4",
    x: -0.22654,
    y: -0.43627,
    width: 1.4531,
    height: 1.8725,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3278973
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3028-3",
    x: -0.24179,
    y: -0.21079,
    width: 1.4836,
    height: 1.4216,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25032949
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3357-1",
    x1: -1837.2,
    x2: -1828.8,
    y1: 993.89,
    y2: 963.55,
    gradientTransform: "translate(2.0242,-12.947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31092f",
    stopOpacity: 0.45994,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9a358b",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3359-4",
    x: -0.081792,
    y: -0.08569,
    width: 1.1636,
    height: 1.1714,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0458434
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3381-9",
    x: -0.2017,
    y: -0.21279,
    width: 1.4034,
    height: 1.4256,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.91636728
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4240-2",
    x: -0.043904,
    y: -0.045406,
    width: 1.0878,
    height: 1.0908,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22602326
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3691-8",
    x: -0.16419,
    y: -0.31587,
    width: 1.3284,
    height: 1.6317,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.401271
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3539-4",
    x1: -1749.6,
    x2: -1757.5,
    y1: 972.9,
    y2: 952.51,
    gradientTransform: "translate(2.0242,-12.947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25090f",
    stopOpacity: 0.75371,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e35fc7",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4272-4",
    x: -0.15571,
    y: -0.11538,
    width: 1.3114,
    height: 1.2308,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.92747093
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3441-6",
    x1: -1489.9,
    x2: -1468,
    y1: 1014.2,
    y2: 986.67,
    gradientTransform: "translate(2.0242,-12.947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25090f",
    stopOpacity: 0.45882,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f46ad6",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4264-7",
    x: -0.091099,
    y: -0.13196,
    width: 1.1822,
    height: 1.2639,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2894499
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3713-3",
    x: -0.48537,
    y: -0.16023,
    width: 1.9707,
    height: 1.3205,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0977768
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4180-8",
    x: -0.26514,
    y: -0.11723,
    width: 1.5303,
    height: 1.2345,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29224015
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4289",
    x: -0.0085866,
    y: -0.021151,
    width: 1.0172,
    height: 1.0423,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.31010176
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4297",
    x1: 886.61,
    x2: 850.02,
    y1: 1083,
    y2: 890.02,
    gradientTransform: "rotate(1.2293,-2165.3,-125649)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3988"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient4504",
    cx: -1504,
    cy: 1074.8,
    r: 32.568,
    gradientTransform: "matrix(1.7331 -.0013466 .00090749 1.168 1103.7 -208.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98fff7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98fff7",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient9840",
    x1: -1804,
    x2: -1756.5,
    y1: 1124,
    y2: 947.78,
    gradientTransform: "translate(2.0242,-12.947)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient3988"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter10182",
    x: -0.0076242,
    y: -0.010649,
    width: 1.0152,
    height: 1.0213,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24356251
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10518",
    x: -0.035861,
    y: -0.025317,
    width: 1.0717,
    height: 1.0506,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25886714
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10685",
    x1: 394.17,
    x2: 391.76,
    y1: 1013.1,
    y2: 1045,
    gradientTransform: "translate(32.809,-202.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5d3e25",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704a2c",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient4086",
    cx: 403.65,
    cy: 1039.8,
    r: 92.179,
    gradientTransform: "matrix(1.3082 .36438 -.21601 .52844 100.2 343.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a120b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131",
    stopOpacity: 0.6902,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4452",
    x: -0.084813,
    y: -0.1827,
    width: 1.1696,
    height: 1.3654,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2628308
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1752",
    x1: 498.55,
    x2: 497.78,
    y1: 809.88,
    y2: 793.59,
    gradientTransform: "translate(-64.899,19.183)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter1786",
    x: -0.026492,
    y: -0.025664,
    width: 1.053,
    height: 1.0513,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.10003137
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1907",
    x1: 407.8,
    x2: 407.59,
    y1: 773.15,
    y2: 766.22,
    gradientTransform: "translate(-5.542,33.734)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1917",
    x1: 455.32,
    x2: 455.53,
    y1: 754.98,
    y2: 751.17,
    gradientTransform: "translate(5.0083,39.172)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1927",
    x1: 381.95,
    x2: 382.16,
    y1: 781.36,
    y2: 773.03,
    gradientTransform: "translate(-4.3372,38.312)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1937",
    x1: 410.53,
    x2: 410.12,
    y1: 797.51,
    y2: 792.29,
    gradientTransform: "translate(-5.0006,35.554)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter1951",
    x: -0.030322,
    y: -0.030322,
    width: 1.0606,
    height: 1.0606,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.064966648
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1963",
    x: -0.083006,
    y: -0.083006,
    width: 1.166,
    height: 1.166,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.10953046
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1975",
    x1: 406.42,
    x2: 406.16,
    y1: 738.67,
    y2: 734.17,
    gradientTransform: "translate(21.401,71.66)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2005",
    x1: 377.98,
    x2: 377.89,
    y1: 708.49,
    y2: 706.05,
    gradientTransform: "translate(-4.3372,80.961)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2033",
    x1: 425.63,
    x2: 425.4,
    y1: 780.3,
    y2: 775.02,
    gradientTransform: "translate(26.514,14.508)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter2043",
    x: -0.069053,
    y: -0.069053,
    width: 1.1381,
    height: 1.1381,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.074245012
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2051",
    x: -0.12873,
    y: -0.12288,
    width: 1.2575,
    height: 1.2458,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.13211828
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2063",
    x1: 379.25,
    x2: 379.26,
    y1: 745.75,
    y2: 740.29,
    gradientTransform: "translate(.097339 50.426)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter2077",
    x: -0.063906,
    y: -0.0644,
    width: 1.1278,
    height: 1.1288,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.12187052
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2081",
    x: -0.038584,
    y: -0.038478,
    width: 1.0772,
    height: 1.077,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.083827992
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2093",
    x1: 451.88,
    x2: 451.84,
    y1: 699.79,
    y2: 697.13,
    gradientTransform: "translate(-7.2287,97.346)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter2115",
    x: -0.086695,
    y: -0.086695,
    width: 1.1734,
    height: 1.1734,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089879476
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2127",
    x1: 417.64,
    x2: 417.19,
    y1: 695.83,
    y2: 690.77,
    gradientTransform: "translate(-1.9276,130.36)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient2218"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter2137",
    x: -0.044873,
    y: -0.045121,
    width: 1.0897,
    height: 1.0902,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.097025638
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2244",
    x: -0.010438,
    y: -0.012986,
    width: 1.0209,
    height: 1.026,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.87713944
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2432",
    x: -0.025102,
    y: -0.080794,
    width: 1.0502,
    height: 1.1616,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.47894443
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2440",
    x: -0.035992,
    y: -0.1128,
    width: 1.072,
    height: 1.2256,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.18178529
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient3428",
    cx: 418.26,
    cy: 756.31,
    r: 38.92,
    gradientTransform: "matrix(1.0419 -.50889 .29786 .60981 -240.88 496.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9afbf7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ec3",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105.37 -187.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-231.51,-480.38)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.84447 .00061267 -.015777 .9837 92.196 -202.07)",
    d: "m478.1 1039.8a74.45 34.567 0 0 1-74.017 34.567 74.45 34.567 0 0 1-74.878-34.165 74.45 34.567 0 0 1 73.147-34.964 74.45 34.567 0 0 1 75.728 33.758",
    fill: "url(#radialGradient4086)",
    filter: "url(#filter4452)",
    opacity: 0.44214,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.98 807.68c-2.2572-0.9904-51.608-27.569-51.608-27.569l53.037-24.832 50.195 22.566z",
    fill: "none",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26315,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.41 755.28-53.017 24.894v39.468l53.007-28.829 0.014-35.533",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.20781
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365.37 780.12-14.418-16.231 52.95-24.011 14.505 15.41z",
    fill: "#eaa86e",
    opacity: 0.74184,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.41 755.28 10.574-19.428 52.616 21.753-12.995 20.24z",
    fill: "#935f37",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.39 780.18-0.28989 0.61409-14.127-16.001-6.4e-4 -0.84473z",
    fill: "#eaa86e",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.27 804.06 0.0155 0.9471 51.013 27.781-0.0715-1.1967z",
    fill: "#916038",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m408.3 832.79 8.7399-23.513-0.0528-1.5941-8.7586 23.91z",
    fill: "none",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.20781,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.52 827.97 0.0567-1.3933 50.85-34.602-0.11353 1.2193z",
    fill: "#eeac70",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeWidth: 0.20781,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.41 755.28-0.0101 35.533 15.957 6.6325 34.247-19.599z",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.09 778.15-0.48271-0.30389 12.995-20.24-0.0233 1.0268z",
    fill: "#935f37",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.20814,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1806.5 -120.54)",
    filter: "url(#filter2244)",
    opacity: 0.94509
  }, /*#__PURE__*/React.createElement("path", {
    id: "halo1",
    d: "m-1811.7 1108.6 3.4759-150.92 98.558 26.556-37.044 109.43-44.621 23.719z",
    fill: "url(#linearGradient9840)",
    opacity: 0.998,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "halo2",
    d: "m-1832.9 1119.3-46.746-25.618-31.665-111.57 103.12-24.425-3.4759 150.92z",
    fill: "url(#linearGradient4297)",
    opacity: 0.91098,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      mixBlendMode: "normal"
    }
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Bubble_mask_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1806.5 -120.54)",
    filter: "url(#filter2244)",
    opacity: 0.94509
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1811.7 1108.6 3.4759-150.92 98.558 26.556-37.044 109.43-44.621 23.719z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1832.9 1119.3-46.746-25.618-31.665-111.57 103.12-24.425-3.4759 150.92z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m416.98 807.68-14.888-8.019 16.303-8.8492 15.961 6.6324z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m416.98 807.68-14.888-8.019 16.303-8.8492 15.961 6.6324z",
    fill: "#fffdff",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1568.2 -72.981)",
    d: "m-1550.5 1052 47.495-20.694 44.569 19.161-24.836 13.666-20.37-8.7878-21.228 10.686z",
    fill: "url(#radialGradient4504)",
    filter: "url(#filter4289)",
    stopColor: "#000000",
    strokeOpacity: 0,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brain"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1495.4 962.06-4.0926 2.7771c-1.1155 1.2549 2.5658 3.0331 4.5311 3.3617 1.7419 0.29133 5.5542 1.6078 6.1388 1.9001 0.5847 0.29231 1.754 2.1924 1.754 2.1924l4.6772-0.87699",
    fill: "none",
    filter: "url(#filter8846-38-2)",
    opacity: 0.87537,
    stopColor: "#000000",
    stroke: "#77276b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 1.4,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1506.5 996.55c1.0975-0.0495 2.2885-1.0474 2.2885-1.0474 0.086-0.58294 0.6959-1.6685 0.2568-1.7488",
    fill: "none",
    filter: "url(#filter3028-3)",
    stopColor: "#000000",
    stroke: "#fdffff",
    strokeOpacity: 0.96739,
    strokeWidth: 0.765,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1535.9 976.25c-0.4146-1.3216-1.9123-1.6229-3.3058-2.5918-0.9409-0.65427-1.034-1.9139-1.8124-2.8097-1.5138 1.5876-0.5266 4.243 0.1789 6.9551 0.1314 1.1907-0.8078 1.9041-1.9154 2.9022-0.4723 1.255-3.0277-0.13748-4.7182-0.58729 0.132 2.6467-0.3283 4.1341 0.4248 7.4291-0.2114 0.20246 3.3891 2.0277 4.2746 2.3889 1.0524 0.42922 6.2674 1.3318 6.256 1.8609 1.1633 2.0834 2.1104 4.1776 3.9129 6.2292 0.6468 0.77952 3.8873 2.1313 5.765 2.1277 4.5337-0.01 6.2473 0.5512 7.0982 0.4238 1.3034-0.1953 1.6386-0.80835 2.5624-1.765-1.1135-1.246-1.7943-2.9325-4.4106-2.6489-3.7471 0.50715-6.1261-1.4928-9.1943-3.2697l-4.5699-5.3226c-0.3682-1.621-0.5886-3.1116-0.3823-4.8157l2.8059-4.6733 0.7577-4.8324z",
    fill: "url(#linearGradient3357-1)",
    filter: "url(#filter3359-4)",
    opacity: 0.68546,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1567.9 -74.829)",
    d: "m-1523.7 1013.7a2.0463 1.9001 0 0 1-2.0344 1.9001 2.0463 1.9001 0 0 1-2.058-1.878 2.0463 1.9001 0 0 1 2.0105-1.9219 2.0463 1.9001 0 0 1 2.0814 1.8556",
    fill: "url(#radialGradient6544-9)",
    filter: "url(#filter6495-1-45)",
    stroke: "url(#radialGradient6433-4-2)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 0.765,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#77276b",
    strokeOpacity: 0.96078
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1500.2 937.27 2.4314-1.7178 1.9094-0.65926c1.7141-0.19867 2.3577 0.0309 3.1356 0.2067",
    fill: "none",
    filter: "url(#filter8894-3-3)",
    opacity: 0.87537,
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1525.2 979.59c-0.8125-0.58465 1.0681-4.0925 1.6078-4.0925l3.6541-1.3155h3.2156",
    fill: "none",
    filter: "url(#filter8838-5-5)",
    opacity: 0.87537,
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.65 746.39c-2.4594-0.0966-5.1071-0.73204-8.2466-2.7755-0.815-1.7505-0.41578-4.1486-0.45351-6.3136 0 0-2.7797-6.8197-2.4923-7.8293 0.82649-2.903 3.6308-5.4543 4.3488-6.9939 0.50794-1.0888 1.5809-6.7243 2.7985-8.1918 0.76592-0.92309 3.937-4.0409 5.9372-3.9902 2.1507-2.1872 4.9402-2.7786 7.6308-3.6168 2.1692-2.9556 6.0467-4.7052 10.144-6.2999 5.7917-1.2752 10.41-1.8917 16.447-1.6462 2.0874-0.0791 5.2386 1.4624 6.8544 2.613 1.4926 1.0629 5.1612 1.4653 6.6314 2.3182 1.8601 1.0791 3.42 3.7767 5.2181 3.8274 2.0446 0.0577 4.3579 2.0508 5.3476 2.3463 1.6346 0.48814 3.1406 6.2412 2.8625 6.3429 3.9768 4.3206 1.8158 9.2344 2.058 13.916-0.43549 1.6929-1.4703 3.3091-4.4687 4.6737-3.0316 3.1777-5.3325 0.80051-5.8024 2.344-0.44565 2.1475-1.3656 6.4348-4.9892 7.9354-1.0684 0.44242-11.514 8.3573-13.179 7.0235-3.1208-0.10412-6.8648 0.23683-8.2122-1.1337-1.2249 1.6574-4.2708 1.754-7.1839 1.9644l-6.119-0.85116c-0.97148 2.239-5.4933 1.4644-9.6116 1.0322-3.2332-0.90877-4.0439-4.1174-5.5192-6.6952z",
    fill: "url(#radialGradient3428)",
    filter: "url(#filter10182)",
    stopColor: "#000000",
    strokeWidth: 0.78544,
    style: {
      fontVariationSettings: "normal",
      mixBlendMode: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#77276b",
    strokeOpacity: 0.96078
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1520.9 995.38 4.3991 3.178",
    filter: "url(#filter8854-2-4)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1453.8 954.74s-1.6594-0.83013-2.1345-1.0494c-0.475-0.21924-0.7673-1.4616-0.7673-1.4616-0.4518-0.97592-1.1776-1.0038-1.8636-1.1693-0.1753 0.3328-0.3774 0.66021-0.2193 1.0597",
    filter: "url(#filter8874-7-5)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m217.24 870.24c2.0463 0 4.2387-0.73083 4.2387-0.73083l-0.29231-4.8234",
    filter: "url(#filter8906-0-6)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m221.48 869.51 1.108 1.5468c0.69453 0.77261-0.11952 1.2392-0.23254 2.2996l-0.82682 0.82683",
    filter: "url(#filter8910-7-2)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m231.6 861.89 0.10335-3.0489-0.6201-1.8603 1.1886-1.3436 3.359-0.9302 2.8422-0.20669 0.56843-0.77515",
    filter: "url(#filter8902-9-5)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m249.2 854.5c1.2654 2.1077-1.3006 4.0124-2.3771 5.7878-0.74576 0.63941-1.6226 3.9551-2.1955 5.1129 2.0397-1.5948 3.5799-2.9032 4.4442-3.824 1.8114-1.2924 3.6925-3.0376 5.3227-3.1523",
    filter: "url(#filter8890-43-5)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m254.39 858.42c1.3608-0.63112 2.7216-0.93308 4.0824-2.3771 2.976-1.9437 3.9267-1.9016 5.3744-1.912 1.563-0.0113 5.4054-1.6909 5.5294-2.1704 0.35758-1.3831 1.7777 1.1385 0.76326 2.1464-0.98503 0.72758-1.6008 1.4024-1.2283 1.9361 0 0 1.6674 1.4323 2.7905 1.8603 2.1666 0.82571 3.1894 3.089 3.0489 3.0489l0.20672 1.8087s-2.5077 0.41263-2.6872 0.31006c-1.1087-0.63361-5.2076-0.42557-5.0126 0.56844-0.0168 0.56844 0.32348 1.1369-0.31006 1.7053",
    filter: "url(#filter8882-1-8)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m274.96 862.76c0.45264 0.93018-0.22819 2.3171 0.51676 3.028 1.2678 1.6279 0.0436 2.2861 0 3.5349 0.42396 1.3895 0.99039 2.0713 1.7053 2.0154",
    filter: "url(#filter8886-2-6)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m249.98 873.02c-3.8002 1.0231-6.0658 2.704-6.0658 2.704l-2.9233 3.581c-1.4979 1.4259-2.3262 3.5567-3.1425 5.7003",
    filter: "url(#filter8834-8-1)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m270.73 883.1-3.5079 2.3386s-2.0658 1.8488-4.9696 1.3154c-2.9037-0.53334-8.1851 0.14619-8.1851 0.14619l-3.9464 1.754-2.0463 2.3386c-0.50517 0.95186-0.71227 1.8739-0.7308 2.7771",
    filter: "url(#filter8842-8-2)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m226.88 903.57c1.326 1.1658 3.0701 2.1922 6.1388 2.7771l3.9464-0.14615 1.6078-2.0463 2.3386-2.3386",
    filter: "url(#filter8850-8-0)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m258.53 908.34s1.9208-2.5072 2.0671-2.8939c0.17063-0.45111-0.0848-4.953-0.51676-4.8576-0.507-1.0398-1.4937-1.264-2.6872-1.1369",
    filter: "url(#filter8830-09-6)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m260.54 905.35c0.87982-1.473 1.4-3.1405 3.7724-4.1341 0.56561-0.23688 1.7431-1.0284 4.9868-3.9533 0.6914-0.77863 2.909-0.0733 3.4882 0.33591 0.61454 0.4341 4.2375-1.2402 5.3744-2.4805 1.1369-1.2402 2.5838-6.0978 2.5838-6.6146 0-0.51676 0.62011-3.824 0.62011-3.824",
    filter: "url(#filter8858-2-3)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m269.07 910s3.9274-3.3073 4.3408-4.1341c0.41341-0.82683 2.5838-1.8603 2.5838-1.8603 1.4867-0.33023 2.4365-1.412 3.6174-2.1704 1.231-1.1713 1.6416-2.3427 2.067-3.514",
    filter: "url(#filter8826-8-0)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m292.86 891.67s1.1119-4.6217 1.5504-5.4987c0.43849-0.87696 2.6309-2.1924 2.6309-2.1924l0.95346-0.34181 1.0928-0.82749c-0.17326-0.25989 1.0716-3.0698 1.6078-3.8002 0.31395-0.42763 0.14191-1.7111-0.16159-2.6751-0.25745-0.81769-0.7154-1.4175-0.7154-1.4175",
    filter: "url(#filter8862-2-9)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m289.3 882.23c0.87693-0.55686 1.6481-1.2346 2.0463-2.3386 0.055-0.83105-0.63909-1.3292-1.1693-1.9001 0.56765-0.78757 1.12-1.5817 1.1899-2.5834 0.38055-0.79538 0.59648-1.5908 0.56402-2.3861-0.8931-0.0505-1.803 0.15176-2.6309-0.87698l-1.599-1.5522c-0.86773-0.45399-1.9363-0.35566-3.0782-0.0556",
    filter: "url(#filter8866-4-1)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m298.94 865.86-4.5311-3.3618c-1.3429 0.0281-1.2949 1.0995-1.6078 1.9001-0.1473 3.3689 0.30824 3.49 0.4385 5.1157l-1.3155 3.5079",
    filter: "url(#filter8870-37-7)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m286.67 854.46c1.0019 1.5878-0.44549 2.9945-1.1693 4.5311-0.85433 0.58465-1.5322 1.1693-1.9001 1.754 0.83378 1.1743 1.6136 2.5375 2.6309 3.0694 0.86757 0.612 1.5591 1.1888 1.4616 1.6078",
    filter: "url(#filter8878-2-9)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m271.03 850.51c1.8353-1.1698 3.2116-0.96267 4.6772-1.0231 0 0 4.3849 0 5.7004 0.58465s4.3849 1.0231 4.3849 1.0231",
    filter: "url(#filter8898-1-2)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m223.52 887.12-4.057-2.2528c-1.0142-0.17656-1.1203-1.2613-1.179-2.3933l1.0162-2.2988 1.447-1.0852",
    filter: "url(#filter8914-4-2)",
    opacity: 0.87537,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 203.23 33.901)",
    d: "m222.04 901.83-2.3785-8.3885 2.704-4.5311 4.0195-5.6273 5.3003-11.221s7.4159-3.6143 7.7082-3.7605c0.29233-0.14615 5.9927-1.1693 6.285-1.2424s5.6273-0.36539 5.6273-0.36539l6.6504 0.73081",
    filter: "url(#filter8918-5-5)",
    opacity: 0.87537,
    stopColor: "#000000",
    strokeWidth: 1.4,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1480.3 944.38 2.2738 1.4469 2.2737-1.5503-2.4804 2.067 0.5167 4.0307",
    filter: "url(#filter11217-5-0)",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.465,
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1535.8 991.01s-2.1242-3.2256-2.331-4.2592c-0.2067-1.0335-0.9217-1.5408-0.048-4.1294 0.8743-2.5886 3.8594-6.319 3.8594-6.319l3.3195-4.6412 1.3436-4.5475s1.8551-3.3474 1.9282-3.7858c0.073-0.4385 4.0926-3.6541 4.0926-3.6541l6.1388-2.1924 3.5079-2.1194 3.2887-2.0463s0.3707-2.325 0.7841-2.8418c0.4135-0.51679 2.1435-2.1482 4.3409-2.8939 2.0117-0.68268 6.7687-1.4043 8.2682-2.5838 0.7636-0.60061 5.3158-1.8854 7.028-1.8603l6.4588-3.0819c0.6555-0.32773 5.5105 0.54962 5.7537 0.72604 4.1128 2.9838 11.328 2.0463 11.328 2.0463",
    filter: "url(#filter4196-1)",
    stopColor: "#000000",
    stroke: "#78276c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.98824,
    strokeWidth: 1.365,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1507.8 962.2-5.9794 2.9523-4.1341 2.9972-1.3436 3.2039c0.7425 0.81364 0 1.0633 1.1459 3.1419l-2.6471 0.10333c0.057-0.36621-0.7644 0.0691-3.4598 1.664l-0.9753 3.3306",
    filter: "url(#filter11572-96-2)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeOpacity: 0.96078,
    strokeWidth: 1.665,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 0.765
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1531.2 952.23 1.5503 2.7905-0.4134 4.6509 1.2402-4.0308 4.2375-1.2402 5.581-1.8603",
    filter: "url(#filter11201-65-4)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1531.2 981.48-0.3101 4.1341s1.4689 1.0234 2.1704 2.5838c1.7073 3.7978 6.1285 5.2679 6.718-0.31007 0.1308-1.2376 3.3636-3.3891 3.3636-3.3891 2.2298 3.8941 4.5298 4.3858 4.7514 2.0028",
    filter: "url(#filter11193-6-8)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1525 972.18s1.4469-4.3408 2.067-5.1676 3.7207-4.3408 3.7207-4.3408l5.5811-2.0671 4.0307-1.1369",
    filter: "url(#filter11205-3-8)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1488.5 963.09 5.9945 2.7905s3.514 1.0335 3.514 1.6536c0 0.62011-0.1034 2.6872-0.1034 2.6872s1.5503-3.2039 2.2738-3.4106 1.1369-3.4106 0.9302-4.0308c-0.2067-0.62011-1.1369-3.1006-1.1369-3.1006l2.5838 6.9246 2.0671 0.2067-0.5168 3.2039",
    filter: "url(#filter11221-3-5)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1512.3 938.9c1.0335-0.62013 3.3072-1.8604 3.3072-1.8604l3.6174 0.51676 1.1369 3.2039 2.7905-0.31006",
    filter: "url(#filter11213-4-5)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1511.1 992.56 1.9001 3.5079s2.9233 1.1693 3.6541 0.29234c0.7309-0.87699 1.4617-4.6772 1.4617-4.6772l-2.3386-3.0694",
    filter: "url(#filter11197-3-1)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1494.2 981.48 10.335-2.2738 1.0335-3.1006",
    filter: "url(#filter11225-5-5)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1454.1 959.68s-3.7207-1.447-4.3408-1.447-1.8603 3.1006-1.8603 3.1006l-1.3436 4.4442",
    filter: "url(#filter11229-0-6)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1502 951.2c0.9302-0.41341 4.5475-0.31004 4.5475-0.31004l1.3436 2.1704s-0.8268-3.4106-0.6201-3.9274c0.2067-0.51676 4.3408-1.2402 4.3408-1.2402",
    filter: "url(#filter11209-1-5)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1542.6 966.19c-0.4134 0-3.3073 2.9972-3.3073 2.9972s0.2067 4.4442 0.5167 4.8576c0.3101 0.41341 2.4805 1.9637 2.4805 1.9637l-0.5167 2.7905",
    filter: "url(#filter11189-9-3)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1525.2 979.59 0.9753-3.3306s1.0935-2.929 2.2766-2.2965c1.1831 0.63249 3.8303 0.52917 3.8303 0.52917l-1.146-3.1419 1.3436-3.2039s4.7054-4.1052 5.0155-4.2085c0.31-0.10335 3.5656-1.9637 3.5656-1.9637",
    filter: "url(#filter4188-9)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeLinejoin: "round",
    strokeOpacity: 0.96078,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1535.2 975.47c-0.1033-0.41341-1.5503-1.2919-1.5503-1.2919s-1.757-0.15502-2.1187-0.46508c-0.3618-0.31007-1.8604-2.3254-1.2919-3.514 0.5684-1.1886 3.0516-1.9193 3.0516-1.9193l0.6174-1.1296",
    filter: "url(#filter4212-4)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeOpacity: 0.96078,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1533.1 978.85c-0.146 0.61491-2.3433 4.1417-2.042 6.1425 0.3351 2.2254 2.0307 4.477 3.1564 5.7391 2.7104 3.0389 6.7406 5.136 8.3923 4.937l2.7349-0.29133c2.9278 0.49363 3.5259 1.8891 4.3992 3.178-1.1145-1.3672-2.2105-2.7507-4.3992-3.178 0.3718-0.55681 1.3481-0.78881 1.2184-1.6724-0.4826-1.9037 0.3463-2.5734 0.5943-2.6355 0.2557-0.064 2.1338-0.077 2.1338-0.077",
    filter: "url(#filter4176-0)",
    stopColor: "#000000",
    stroke: "#77276c",
    strokeOpacity: 0.86667,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1526.2 951.07c-0.2611-1.078 0.049-3.9202 0.5141-4.2302 0.4651-0.31006 4.2891-1.4986 4.2891-1.4986l2.0698-1.6609",
    filter: "url(#filter4184-9)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeOpacity: 0.96078,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1513.2 954.58c1.7053-0.41341 6.1469 1.0924 6.4052 0.98907 0.1258-0.0503 1.3056 0.0954 2.483 0.25822 1.2403 0.1715 2.478 0.36191 2.478 0.36191l0.6718 2.4288",
    filter: "url(#filter2440)",
    stopColor: "#000000",
    stroke: "#78276c",
    strokeLinejoin: "round",
    strokeOpacity: 0.98824,
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#77276b",
    strokeOpacity: 0.96078
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1510.7 953.32s-1.1766-2.6578-1.3833-3.3296c-0.1023-0.33245 0.3775-1.4242 0.9385-2.4986 0.5726-1.0968 1.2298-2.1757 1.4386-2.4106 0.2064-0.23226 0.4644-0.95425 0.671-1.6189 0.2071-0.66629 0.3625-1.275 0.3625-1.275",
    filter: "url(#filter4252-5)",
    stopColor: "#000000",
    strokeWidth: 1.3,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1495.4 962.06-2.8415 2.5639 0.4385 3.2156 6.285 1.3155 4.4492 3.1365 4.6772-0.87699-4.6772 0.87699-2.951 2.3446s-2.5579 1.1693-3.0694 1.4251c-0.5116 0.2558-3.2522-0.40196-4.1657-0.47504-0.9135-0.0731-4.7503-0.25577-4.7503-0.25577s-2.7405 0.54811-2.8867 0.69427c-0.1461 0.14615-2.3751 1.8636-2.3751 1.8636l-2.3021 3.106-0.8857 1.9672",
    filter: "url(#filter4160-2)",
    stopColor: "#000000",
    strokeWidth: 1.2999,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1499.3 997.52c1e-4 0 2.0155-2.9972 2.0155-2.9972l0.043-4.9146-3.1954-0.97647 3.3415 1.0496-0.073 2.5579s3.2156-1.6078 3.8733-1.754 5.0426-4.0926 5.0426-4.0926l2.5579-0.58464s2.6309 0.65772 3.2886 0.58464c0.6578-0.0731 4.5311-2.7771 4.5311-2.7771s0.3654-2.704 0.3654-3.1425 1.0505-6.6208 1.0505-6.6208",
    filter: "url(#filter4164-1)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1453.8 954.74s-2.7835-2.7608-3.0758-2.7608c-0.2924 0-3.4349 0.21926-4.0926 0.29234-0.6577 0.0731-3.9464 1.9001-3.9464 1.9001l-0.2923 3.2156 0.3654 2.7771-1.3886 4.6772-0.8039 3.8002v2.1924l0.1462-2.3386 1.0141-6.291-5.6913-2.1133",
    filter: "url(#filter4152-5)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1487.8 943.06s-0.2192 2.9963 0.073 2.9963c0.2923 0 3.0694 2.4848 3.0694 2.4848l1.8046 3.4051-2.9739-0.0433c-0.6962 0.0244-2.3799 0.0487-3.581 0.0731l-1.4548 2.554 1.4548-2.554h4.3849l3.8237 0.53874-0.9735 2.75 0.2923 3.1425",
    filter: "url(#filter4144-4)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1471.2 943.64-1.1693 4.5311-1.9001 1.754 1.1781 2.8562 2.9144 1.821",
    filter: "url(#filter4148-1)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1500.6 937.62 1.3199-1.5842c0.4445-0.45672 1.146-1.6619 2.7362-1.4973l1.9589 0.18923c1.4128 0.0778 2.2061 0.49891 2.6611 0.49215 1.3308-0.0198 0.3642-1.4812 0.1555-1.8613",
    filter: "url(#filter4216-4)",
    stopColor: "#000000",
    strokeWidth: 1.3,
    style: {
      fontVariationSettings: "normal"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1506.4 988.62c0.6699-1.99 1.2987 4.8816 0.048 6.0832-0.4134 0.10082-1.4293 0.0535-1.5521-0.91047-1.8742-0.73661-2.3648-1.7025-2.7589-2.5811",
    filter: "url(#filter3141-1)",
    stopColor: "#000000",
    stroke: "#7a296e",
    strokeWidth: 0.765,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1510.7 991.21c0.1178 0.67745 4.0347 3.6904 4.311 3.4916 0.7603-0.0117 0.3252-5.9814-0.048-6.0832",
    filter: "url(#filter4172-9)",
    stopColor: "#000000",
    stroke: "#832d76",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1508.1 942.56-0.9122 1.8374-1.9679 2.5483-0.6322 2.3323 0.9082 2.3752c0.018-0.0719 2.1605-2.567 2.2803-2.6609 1.0912-0.85479 2.8184-1.9184 3.1353-2.1079 0.6364-0.38063 5.2329-1.2437 6.8849-1.5638-0.023-0.32641 3.7411-1.5506 4.4044-1.5173 0.9457 0.0474 6.7807-1.8906 6.7807-1.8906s3.4767-2.204 3.6617-2.3096c0.1851-0.10568 3.5024 0.29444 3.5024 0.29444l5.8233 2.3689 7.0441 0.0915c4.4846 0.34801-2.2601-1.8362-2.8954-2.8168-2.7164-0.58363-6.1408-1.4856-9.0738-1.4297-1.6306 9e-3 -4.3429-0.34678-7.3259 0.69978-1.1493 5e-3 -2.9338 1.3899-4.1611 1.9815-1.4944-0.4659-2.9913 1.2557-5.9196 0.55046-4.5144 3.0456-7.272 3.3768-11.044 4.5472 0.056-0.58718 0.6162-1.0185 0.405-1.7011-0.021-0.0667-0.2123-0.19209-0.1433-0.84336-0.083-1.2817 0.2859-1.9139-0.925-1.8456z",
    fill: "#25090f",
    fillOpacity: 0.75371,
    filter: "url(#filter2432)",
    opacity: 0.24926,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1500.6 940.77c0.4672-0.0933 4.2965-3.0954 4.2965-3.0954l1.8799-0.89003s1.4916 0.34214 2.0577 0.45766 2.4452 0.13918 2.4452 0.13918l1.3178-2.6052",
    fill: "none",
    filter: "url(#filter3669-8)",
    stopColor: "#000000",
    stroke: "#f8fefe",
    strokeWidth: 0.765,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1497.5 938.5 1.2065-0.82699 0.6058-0.52972 1.7061-0.0151 0.4544 0.5008",
    fill: "none",
    filter: "url(#filter3687-8)",
    opacity: 0.86053,
    stopColor: "#000000",
    stroke: "#faf9f2",
    strokeWidth: 0.965,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1492.7 983.54a2.0463 1.9001 0 0 1-2.0344 1.9001 2.0463 1.9001 0 0 1-2.058-1.878 2.0463 1.9001 0 0 1 2.0105-1.9219 2.0463 1.9001 0 0 1 2.0814 1.8557",
    fill: "url(#linearGradient2840-3)",
    filter: "url(#filter6793-4)",
    stroke: "url(#radialGradient6433-4-2)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 0.765,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1515.8 962.27c-0.7211-0.11884-2.7615 1.0262-2.7615 1.0262l-1.3877 2.0378-0.9754 2.0983",
    filter: "url(#filter2900-6)",
    stopColor: "#000000",
    stroke: "url(#radialGradient2874-7)",
    strokeWidth: 0.865,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1485.1 979.78 3.1991-0.78531 0.3126-0.94358",
    filter: "url(#filter2958-4)",
    stopColor: "#000000",
    stroke: "#f9f8fc",
    strokeWidth: 0.765,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1487.1 996.54 1.5081-2.8363 2.6573-2.1914s3.7394-2.039 3.8961-2.1132 2.5576-1.1598 2.5576-1.1598l0.5038-1.7983",
    filter: "url(#filter3381-9)",
    stopColor: "#000000",
    stroke: "#fbf8f8",
    strokeWidth: 0.565,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1488.8 999.18s1.8941-3.2805 2.1133-3.719 5.1157-3.5079 5.1157-3.5079 3.581-1.6078 4.3118-2.1194 1.0682-2.3326 1.0682-2.3326",
    filter: "url(#filter4240-2)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeLinecap: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 1.3,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1484.3 991.4c0.3941-0.30169 1.7185-1.7981 1.7185-1.7981l1.7743-0.78893 2.4366-0.33539",
    filter: "url(#filter3691-8)",
    opacity: 0.8546,
    stopColor: "#000000",
    stroke: "#fefdfc",
    strokeWidth: 0.565,
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1464.2 979.85-0.7565-4.3925 6.5099-4.0005s1.0721-3.223 1.0918-3.3852c0.079-0.64442-0.1953-2.3431-0.1919-2.4981 0-0.15498 0.036-2.8938 0.036-2.8938-0.1543-1.3116 0.7873-1.5144 2.0493-1.5584 0 0 2.6424 0.90958 2.7727 0.86067 0.1303-0.0489 2.226-0.15897 2.226-0.15897l-0.1426 4.2354s-0.6215 2.4677-0.572 2.5722c-0.043 0.80024-0.1488 2.0902-0.1488 2.0902l-0.016 1.938-1.1563 2.0944c-1.6876 1.5661-0.2929 0.93061-1.3018 1.6519l-1.584 1.0962c0.1376-0.11492-2.8008 1.4307-3.8354 2.1473-1.9628 0.426-2.5687 0.52055-2.9065 0.55791-4.4028 0.48694-2.6392-2.7995-2.7198-1.5068",
    fill: "url(#linearGradient3539-4)",
    filter: "url(#filter4272-4)",
    opacity: 0.62908,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1465 980.85s-0.1948-4.6157-0.049-4.908c0.1462-0.29234 3.2887-2.9233 3.6541-3.0694 0.3654-0.14616 3.8731-1.3179 3.687-2.3656-0.2599-1.4632-1.2573-6.228-0.1741-7.5798",
    fill: "none",
    filter: "url(#filter4232-3)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeLinecap: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 1.3,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1486.7 996.56c0.9777-2.9651 6.4214-4.5903 5.4756-4.3299l5.0603-2.3744 1.5161-3.3794s1.1384-1.0725 3.3948-1.4819c1.9676-0.35696 3.6451-3.4402 3.8943-4.0312l2.153-4.373 0.5466 4.5431c-0.5708 1.6339-0.4663 2.5753-1.6568 4.8875-0.4619 1.1864-0.3186 1.6723-3.3055 4.3226-1.7901 0.8329-3.5971 1.6051-5.2017 3.1082-3.8807 2.3044-7.6566 4.7623-12.178 6.1282l-9.9446-0.47971-2.0499-1.2967 1.1273-1.4378c1.5598-1.7302 1.0146-4.0588 4.2067-4.9725 0.012 0.95334-0.2863 4.6238 1.2801 6.2567 2.1258 0.38598 4.0112-4e-3 5.6813-1.0898z",
    fill: "url(#linearGradient3441-6)",
    filter: "url(#filter4264-7)",
    opacity: 0.77745,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1534.3 950.98c-4.4694 5.2405-1.7384 2.7509-1.6172 3.7664 0 0 0.867-0.93648 0 0l-2.1188 3.1006 2.6469-0.45773 1e-4 -2e-5c-1.7083-1.0407-2.6405-1.415-1.7111-0.84887l0.5027 1.8279 0.2466 0.89679 0.9013 3.2773",
    fill: "none",
    filter: "url(#filter3713-3)",
    opacity: 0.61424,
    stopColor: "#000000",
    stroke: "#77256b",
    strokeWidth: 2.465,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.77638 -.017043 .01666 .79424 1566.5 -66.889)",
    d: "m-1535.9 954.74c0.052 0.31007-0.5685 2.8422-0.5685 2.8422l-1.5503 0.25839 1.7111 0.84887 0.8727 2.045",
    fill: "none",
    filter: "url(#filter4180-8)",
    stopColor: "#000000",
    stroke: "#77276b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.96078,
    strokeWidth: 1.3,
    style: {
      fontVariationSettings: "normal"
    }
  }), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "25s",
    from: "0 0",
    keyTimes: "0; 0.15; 0.3; 0.45; 0.6; 0.75; 0.9; 1",
    repeatCount: "indefinite",
    to: "0 -2",
    type: "translate",
    values: "0,2; 0,-3; 0,2; 0,-1; 0,5; 0,-2; 0,1; 0,-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m416.98 807.68 0.0629 1.3682 20.478 18.92 0.0567-1.3933z",
    fill: "#8a603e",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.20781,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365.37 780.12 0.0163 39.529 51.578 26.815 0.014-38.775z",
    fill: "#704a2c",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.31418,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.97 846.46 7.6057-4.4369 44.04-30.36-8e-3 -33.813-51.624 29.835z",
    fill: "#8a6036",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.31418,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.04 809.28 4.2391 24.54 13.086-8.6561z",
    fill: "url(#linearGradient10685)",
    filter: "url(#filter10518)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.37 780.12-8.1064 23.948 50.956 27.531 8.7586-23.91z",
    fill: "#916038",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.20781,
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.98 807.68 20.597 18.895 50.85-34.602-19.823-14.128z",
    fill: "#eeac70",
    stopColor: "#000000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.20781,
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Bubble_mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m437.58 826.69a4.5311 4.6772 0 0 1-4.5047 4.6771 4.5311 4.6772 0 0 1-4.5571-4.6228 4.5311 4.6772 0 0 1 4.4518-4.7309 4.5311 4.6772 0 0 1 4.6088 4.5678",
    fill: "url(#linearGradient1752)",
    filter: "url(#filter1786)",
    opacity: 0.86994,
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "30s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m404.95 804.64a2.5711 2.5711 0 0 1-2.5562 2.571 2.5711 2.5711 0 0 1-2.5859-2.5412 2.5711 2.5711 0 0 1 2.5261-2.6006 2.5711 2.5711 0 0 1 2.6152 2.5109",
    fill: "url(#linearGradient1907)",
    filter: "url(#filter1951)",
    opacity: 0.86994,
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "20s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m461.87 792.99a1.5834 1.5834 0 0 1-1.5742 1.5834 1.5834 1.5834 0 0 1-1.5926-1.565 1.5834 1.5834 0 0 1 1.5557-1.6016 1.5834 1.5834 0 0 1 1.6106 1.5464",
    fill: "url(#linearGradient1917)",
    filter: "url(#filter1963)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform4 || (_animateTransform4 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "12s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m381.11 817.68a2.5711 2.737 0 0 1-2.5562 2.7369 2.5711 2.737 0 0 1-2.5859-2.7051 2.5711 2.737 0 0 1 2.5261-2.7684 2.5711 2.737 0 0 1 2.6152 2.6729",
    fill: "url(#linearGradient1927)",
    opacity: 0.86994,
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform5 || (_animateTransform5 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "15s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m408.23 831.66a2.815 2.815 0 0 1-2.7987 2.815 2.815 2.815 0 0 1-2.8312-2.7823 2.815 2.815 0 0 1 2.7658-2.8473 2.815 2.815 0 0 1 2.8633 2.7492",
    fill: "url(#linearGradient1937)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform6 || (_animateTransform6 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "40s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m430.4 808.92a2.6071 2.6143 0 0 1-2.592 2.6142 2.6071 2.6143 0 0 1-2.6221-2.5838 2.6071 2.6143 0 0 1 2.5615-2.6443 2.6071 2.6143 0 0 1 2.6519 2.5531",
    fill: "url(#linearGradient1975)",
    filter: "url(#filter2081)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform7 || (_animateTransform7 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "17s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m374.76 788.63a1.2316 1.2902 0 0 1-1.2244 1.2902 1.2316 1.2902 0 0 1-1.2386-1.2752 1.2316 1.2902 0 0 1 1.21-1.305 1.2316 1.2902 0 0 1 1.2527 1.26",
    fill: "url(#linearGradient2005)",
    filter: "url(#filter2051)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform8 || (_animateTransform8 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "40s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m453.35 793.14a1.2902 1.2902 0 0 1-1.2827 1.2902 1.2902 1.2902 0 0 1-1.2976-1.2752 1.2902 1.2902 0 0 1 1.2676-1.305 1.2902 1.2902 0 0 1 1.3124 1.26",
    fill: "url(#linearGradient2033)",
    filter: "url(#filter2043)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform9 || (_animateTransform9 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "8s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m381.72 793.83a2.2884 2.2709 0 0 1-2.2751 2.2708 2.2884 2.2709 0 0 1-2.3016-2.2444 2.2884 2.2709 0 0 1 2.2484-2.2969 2.2884 2.2709 0 0 1 2.3277 2.2178",
    fill: "url(#linearGradient2063)",
    filter: "url(#filter2077)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform10 || (_animateTransform10 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "15s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m445.73 796.1a1.2441 1.2441 0 0 1-1.2368 1.2441 1.2441 1.2441 0 0 1-1.2512-1.2296 1.2441 1.2441 0 0 1 1.2223-1.2583 1.2441 1.2441 0 0 1 1.2654 1.215",
    fill: "url(#linearGradient2093)",
    filter: "url(#filter2115)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform11 || (_animateTransform11 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "12s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -140",
    type: "translate"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m418 823.95a2.5947 2.5804 0 0 1-2.5796 2.5804 2.5947 2.5804 0 0 1-2.6096-2.5504 2.5947 2.5804 0 0 1 2.5493-2.61 2.5947 2.5804 0 0 1 2.6392 2.5201",
    fill: "url(#linearGradient2127)",
    filter: "url(#filter2137)",
    style: {
      paintOrder: "stroke fill markers"
    }
  }, _animateTransform12 || (_animateTransform12 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "30s",
    from: "0 0",
    repeatCount: "indefinite",
    to: "0 -130",
    type: "translate"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainOutOfBoxAnimatedBubblesOutOfBox);
export default __webpack_public_path__ + "static/media/BrainOutOfBoxAnimated_bubblesOutOfBox.3f3a34158f36efe6928a7035671f5d54.svg";
export { ForwardRef as ReactComponent };